<template>
  <div class="pages">
    <template v-if="loading">
      <InfraHeroPlaceholder />

      <InfraBannerPlaceholder />
    </template>

    <GrootContentErrorPage
      v-else-if="exception"
      :language="locale" />

    <template v-else-if="content.contentfulType === 'content-page-assembly'">
      <GrootContentPage
        :breadcrumbs="breadcrumbItems"
        :content="content">
        <GrootFiberDeliveryTimes
          v-if="showMap && !exceptionDelivery"
          :deliveryTimes="deliveryTime"
          :language="locale" />
      </GrootContentPage>
    </template>

    <template v-else>
      <GrootHeroBanner
        :title="content.banner.heading"
        :preamble="content.banner.description"
        :breadcrumbs="breadcrumbItems" />

      <ContentContainer
        class="mt-5"
        :content="content.content"
        :faq="content.faq" />
    </template>
  </div>
</template>

<script>
import {
  mapState, mapActions
} from 'vuex'
import {
  InfraBannerPlaceholder,
  InfraHeroPlaceholder
} from 'tws-vue-components'
import {
  GrootContentPage,
  GrootHeroBanner,
  GrootFiberDeliveryTimes,
  GrootContentErrorPage
} from 'groot-components'
import { isLoggedIn } from '@/utils/user.utils'
import ContentContainer from '@/apps/pages/containers/ContentContainer'
import { applyReactInVueWithOptions } from '@/utils/react.utils'

export default {
  components: {
    ContentContainer,
    InfraBannerPlaceholder,
    InfraHeroPlaceholder,
    GrootContentPage: applyReactInVueWithOptions(GrootContentPage),
    GrootHeroBanner: applyReactInVueWithOptions(GrootHeroBanner),
    GrootFiberDeliveryTimes: applyReactInVueWithOptions(GrootFiberDeliveryTimes),
    GrootContentErrorPage: applyReactInVueWithOptions(GrootContentErrorPage)
  },
  data () {
    return {
      locale: this.$route.params?.locale
    }
  },
  computed: {
    ...mapState('Pages', [
      'loading',
      'exception',
      'content'
    ]),
    ...mapState('map/deliveryTime', [
      'exceptionDelivery',
      'deliveryTime'
    ]),
    banner () {
      return {
        heading: this.content?.fields.pageBanner.fields.heading,
        description: this.content?.fields.pageBanner.fields.description
      }
    },
    showMap () {
      const path = this.$route.path.replace(/^\/en\//, '/')
      return path === '/natinformation/Leveranstider-Fiber'
    },
    breadcrumbItems () {
      return [
        {
          title: isLoggedIn() ? this.$t('breadcrumbs.dashboard-logged-in.title') : this.$t('breadcrumbs.dashboard.title'),
          path: isLoggedIn() ? '/dashboard' : '/',
          routerLink: false
        },
        ...this.getMappedBreadcrumbItems()
      ]
    }
  },
  watch: {
    '$route.path' (newPath) {
      this.loadContent(newPath)
    }
  },
  async created () {
    await this.fetchDeliveryTime()
    await this.loadContent(this.$route.path)

    if (this.content) {
      document.title = [...this.content.breadcrumbTitles].pop()
    }
  },
  methods: {
    ...mapActions('Pages', ['loadContent']),
    ...mapActions('map/deliveryTime', ['fetchDeliveryTime']),
    getMappedBreadcrumbItems () {
      const slug = this.content.slug
      const slugParts = slug.split('/')
      const slugs = slugParts.slice(1).map((_, index) => slugParts.slice(0, index + 2).join('/'))

      const breadcrumbTitles = this.content.breadcrumbTitles

      return breadcrumbTitles.map((title, index) => ({
        title: title,
        path: slugs[index],
        routerLink: false
      }))
    }
  }
}
</script>
<style lang="scss" scoped>
@use '@purpurds/tokens/breakpoint/variables' as breakpoints;
@use 'src/apps/public-landing/assets/scss/purpur-spacing-variables' as spacing;
@import "tws-core-atoms/variables.scss";

.bottom-text {
  margin-top: 10rem;
}

.exception-alert {
  margin-top: 5rem;
}

::v-deep ol {
  margin-bottom: 0px;
}

::v-deep .infra-generic-banner__heading {
  color: black;
}

::v-deep .contentful-rich-text-container {
  padding: 0;
}

::v-deep ul li p, ul li p.paragraph-100 {
  margin: 0 !important;
}
</style>
